import SummaryIcon from "./SummaryIcon";

function toWrapperClass(inputClassName = "") {
    return String(inputClassName)
        .split(/\s+/)
        .filter((cls) => cls && cls !== "form-control")
        .concat(["form-input-with-icon", "px-0"])
        .join(" ");
}

function ViewOnlyTextbox({ name, value, showSummaryDetails, labelClassName, label, inputClassName, rowClassName }) {
    const input = (
        <input
            type="text"
            id={name}
            name={name}
            readOnly={true}
            value={value}
            style={{ cursor: "not-allowed" }}
            className={showSummaryDetails ? "form-control" : inputClassName}
        />
    );

    const content = (
        <>
            {label ? <label htmlFor={name} className={labelClassName}>{label}</label> : null}
            {showSummaryDetails ? (
                <div className={toWrapperClass(inputClassName)}>
                    {input}
                    <SummaryIcon onClickHandler={showSummaryDetails} />
                </div>
            ) : (
                input
            )}
        </>
    );

    if (rowClassName) {
        return <div className={rowClassName}>{content}</div>;
    }

    return content;
}

export default ViewOnlyTextbox;
